import React, { useMemo } from "react";
import { Badge, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Flex, Tooltip } from "antd";
import { convertKiBtoGiB, renderConditionStatus } from "../../utils";
import AppTag from "../common/AppTag";

type Props = {
  item: any;
  onClick: React.MouseEventHandler<HTMLDivElement>;
}

export default function ClusterNodeItem({ item, onClick }: Props) {

  const labelsCount = useMemo(() => {
    const keywords = ['arch', 'hostname', 'role'];

    const matchedLabels = Object.keys(item.metadata.labels)
      .filter((key) => keywords.some((word) => key.includes(word)));

    return matchedLabels.length;
  }, [item]);

  const readyItem = useMemo(() => {
    return item.status.conditions.find((item: any) => item.type === "Ready");
  }, [item]);

  return (
    <Card className="app-list-item" onClick={onClick}>
      <Card.Header className="list-item-header bg-cluster-node">
        <div className="list-item-icon">
          <FontAwesomeIcon icon={solid("circle-nodes")} />
        </div>
        <div className="header-content">
          <Tooltip title={item.metadata.name} mouseEnterDelay={0.3}>
            <h5 className="list-item-title">{item.metadata.name}</h5>
          </Tooltip>
          {!!readyItem && (
            <Badge className="bg-light bg-opacity-50 border text-dark" pill={true}>
              <span className="align-items-center">
                {readyItem.type}{renderConditionStatus(readyItem, true)}
              </span>
            </Badge>
          )}
          <div className="tags-wrapper my-2">
            {item.status.conditions.filter((item: any) => item.type !== "Ready" && !["PID"].some((word: string) => item.type.includes(word))).map((condition: any, index: number) => (
              <Badge key={index} className="bg-light bg-opacity-50 border text-dark me-1" pill={true}>
                <span className="align-items-center text-center">
                  {condition.type}{renderConditionStatus(condition)}
                </span>
              </Badge>
            ))}
          </div>
          <AppTag tag={`${labelsCount} Label${labelsCount === 1 ? "" : "s"}`} color="blue-inverse" />
        </div>
      </Card.Header>
      <Card.Body className="p-2">
        <Flex className="justify-content-around">
          <Tooltip title="CPUs" mouseEnterDelay={0.25}>
            <div>
              <FontAwesomeIcon icon={solid("microchip")} fixedWidth />
              <span className="ms-2">{item.status.capacity.cpu}</span>
            </div>
          </Tooltip>
          <Tooltip title="RAM" mouseEnterDelay={0.25}>
            <div className="project-stat">
              <FontAwesomeIcon icon={solid("memory")} fixedWidth />
              <span className="ms-2">{convertKiBtoGiB(item.status.capacity.memory)}</span>
            </div>
          </Tooltip>
        </Flex>
      </Card.Body>
    </Card>
  )
}